import { PDFDownloadLink } from "@react-pdf/renderer";
import { Button } from "antd";
import moment from "moment";
import React, { memo, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { usePDF } from "react-to-pdf";

import { api, endpoint } from "@/api";
import appConfig from "@/config/appConfig";
import ReactPDF from "./ReactPDF";
import ReportLayout from "./ReportLayout";
import { useSelector } from "react-redux";

const ViewReport = memo(() => {
  const navigate = useNavigate();
  const { targetRef } = usePDF();
  const { id } = useParams();
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [layouts, setLayouts] = useState({});

  const { userDetails } = useSelector((state) => state.user);
  const firstBusiness = userDetails?.business?.[0] || {};

  const getReport = async () => {
    try {
      if (!isLoading) {
        setIsLoading(true);
        const data = await api.get(endpoint.customReport + "/" + id);
        if (data?.result) {
          setData(data.result);
          setLayouts(data.result.layouts);
        }
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getReport();
  }, [id]);

  useEffect(() => {
    document.title = `${appConfig.name} - View Report `;
  }, []);

  return (
    <div className="px-md-3 mt-3">
      <div className="border p-3">
        <div className="d-flex align-items-center justify-content-between">
          <div>
            <label className="az-content-label">Manage Report</label>
            <span className="d-block py-2">View Report: {data?.name}</span>
          </div>
          <div className="ms-auto">
            {data && data.image?.url && (
              <>
                <PDFDownloadLink
                  document={
                    <ReactPDF
                      name={data.name}
                      img={data.image?.url}
                      updatedAt={data.updatedAt}
                      firstBusiness={firstBusiness}
                    />
                  }
                  fileName={`${data?.name}_${moment().format("DDMMYY_hhmmss")}.pdf`}
                >
                  {({ loading }) => (
                    <button className="btn btn-primary">{loading ? "Loading PDF..." : "Download PDF"}</button>
                  )}
                </PDFDownloadLink>
              </>
            )}
          </div>
        </div>
        <hr className="mt-0 mb-5" />
        <div className="pb-5 px-3">
          <div className="bg-layout" ref={targetRef}>
            {data.data?.length !== 0 ? (
              <ReportLayout gridData={data.items} layouts={layouts} setLayouts={setLayouts} mode="view" />
            ) : (
              <div>No Data Found</div>
            )}
          </div>
          <div className="d-flex justify-content-end mt-3 gap-2">
            <Link to={`/edit-Report/${id}`}>
              <Button type="primary"> Edit </Button>
            </Link>
            <Button onClick={() => navigate(-1)} type="primary" className="bg-secondary">
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
});

export default ViewReport;

ViewReport.displayName = "ViewReport";
